import { withStyles } from '@material-ui/core';
import DiscountBlock from './DiscountBlock';

const styles = ({ spacing }) => ({
    root: {
        margin: spacing(2, 0),
        padding: spacing(2),
    },
});

export default withStyles(styles)(DiscountBlock);
